import {BasicWordOrder, Grammar, Position, Prepositions} from "./grammar";

export function isEqual(g1: Grammar, g2: Grammar): boolean {
  for (const key of Object.keys(g1)) {
    if (key === "name") {
      continue;
    }

    // @ts-ignore
    if (g1[key] !== g2[key]) {
      return false;
    }
  }

  return true;
}

export const ENGLISH: Grammar = {
  name: "English",
  description: "A West Germanic language spoken originally by the Anglo-Saxon tribes of England and now by more than "
    + "a billion around the world. Genealogically it is closest to Dutch, German, and the languages of Scandinavia, "
    + "though it has taken a large proportion of vocabulary from French and Latin.",
  wordOrder: BasicWordOrder.SubjectVerbObject,
  indefiniteArticle: true,
  definiteArticle: true,
  nominalGender: false,
  countNouns: true,
  prepositions: Prepositions.Prepositions,
  adjunctPosition: Position.PostVerb,
  verbConjugation: true,
  nominalInflection: false,
  postNominalAdjectives: false,
};

export const DEFAULT: Grammar = {...ENGLISH, name: ""};

export const RUSSIAN: Grammar = {
  name: "Russian",
  description: "An East Slavic language closely related to Ukrainian and Belarusian. Compared to the languages of Western "
    + "Europe, it has retained a complicated system of noun declensions. Its phonological system is marked by a systematic "
    + "contrast between palatalized and unpalatalized consonants – and a propensity for formidable consonant clusters.",
  wordOrder: BasicWordOrder.SubjectVerbObject,
  indefiniteArticle: false,
  definiteArticle: false,
  nominalGender: true,
  countNouns: true,
  prepositions: Prepositions.Prepositions,
  adjunctPosition: Position.PostVerb,
  verbConjugation: true,
  nominalInflection: true,
  postNominalAdjectives: false,
};

export const FRENCH: Grammar = {
  name: "French",
  description: "A Romance language of Western Europe, also spoken throughout France's former colonies in Africa. "
    + "Like all Romance languages, French has a system of grammatical gender and moderately complex verb conjugations. "
    + "Phonologically it is notable for its guttural 'R' sound and large inventory of vowels.",
  wordOrder: BasicWordOrder.SubjectVerbObject,
  indefiniteArticle: true,
  definiteArticle: true,
  nominalGender: true,
  countNouns: true,
  prepositions: Prepositions.Prepositions,
  adjunctPosition: Position.PostVerb,
  verbConjugation: true,
  nominalInflection: false,
  postNominalAdjectives: true,
};

export const CHINESE: Grammar = {
  name: "Chinese",
  description: "Properly speaking, a group of related Sino-Tibetan dialects rather than a single language. Standard "
    + "Chinese is distinguished by a lack of inflection or conjugation, a topic-prominent structure, and phonetic tones. "
    + "Other Chinese dialects – some of them with tens of millions of speakers – share these features to varying degrees "
    + "but differ in vocabulary and pronunciation.",
  wordOrder: BasicWordOrder.SubjectVerbObject,
  indefiniteArticle: true,
  definiteArticle: false,
  nominalGender: false,
  countNouns: false,
  prepositions: Prepositions.Both,
  adjunctPosition: Position.PreVerb,
  verbConjugation: false,
  nominalInflection: false,
  postNominalAdjectives: false,
};

export const HINDI: Grammar = {
  name: "Hindi",
  description: "An Indo-Aryan language spoken by hundreds of millions in India. As part of the Indo-European language family, "
    + "it is distantly related to English and most other European languages. Hindi is mutually intelligible to a "
    + "degree with the Urdu language of Pakistan, though they are written in different scripts",
  wordOrder: BasicWordOrder.SubjectObjectVerb,
  indefiniteArticle: true,
  definiteArticle: false,
  nominalGender: true,
  countNouns: true,
  prepositions: Prepositions.Postpositions,
  adjunctPosition: Position.PreVerb,
  verbConjugation: true,
  nominalInflection: true,
  postNominalAdjectives: false,
};

export const ALL = [ENGLISH, FRENCH, RUSSIAN, HINDI, CHINESE];
